import { motion } from "framer-motion";
import { Gift } from "lucide-react";
import { toast } from "sonner";
import { GIFTS, IMAGES } from "@/data/content";
import { prefillEnquiry } from "@/lib/scroll";
import { SectionHeading } from "./PriceMenu";

export const Gifts = () => (
  <section id="gifts" data-testid="gifts-section" className="mx-auto max-w-7xl px-6 py-24 lg:px-10 lg:py-32">
    <SectionHeading eyebrow="Gifts with Cake" title="Treat Boxes & Gifts" testId="gifts-heading" />
    <motion.p
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.2 }}
      className="mx-auto mt-5 max-w-xl text-center text-sm leading-relaxed text-[#67718A]"
    >
      Add a treat box to your cake order, or send one on its own — a simple, sweet gift
      for birthdays, thank-yous and just because.
    </motion.p>
    <motion.p
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.3 }}
      data-testid="gifts-order-note"
      className="mx-auto mt-6 max-w-2xl rounded-sm border border-[#D4AF37]/25 bg-[#FBF7EE]/70 px-6 py-4 text-center text-sm leading-relaxed text-[#2F4A78]"
    >
      <span className="font-semibold text-[#8A6D1F]">Please note:</span> all cookies, brownies, cupcakes and bento
      cakes are made to order — please allow at least <span className="font-semibold text-[#1B3A6B]">3 days' notice</span>.
      Combined orders are welcome: add any treat box to your cake order and we will prepare everything together for
      the same collection day.
    </motion.p>

    <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4">
      {GIFTS.map((g, i) => (
        <motion.div
          key={g.id}
          data-testid={`gift-card-${g.id}`}
          initial={{ opacity: 0, y: 28 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.6, delay: i * 0.12 }}
          whileHover={{ y: -6 }}
          className="group overflow-hidden rounded-sm border border-[#D4AF37]/20 bg-[#FFFFFF]/60 backdrop-blur-xl transition-colors duration-500 hover:border-[#D4AF37]/50"
        >
          <div className="relative overflow-hidden">
            <img
              src={IMAGES[g.image]}
              alt={g.name}
              className="aspect-[4/3] w-full object-cover transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <span className="absolute right-4 top-4 rounded-full border border-[#D4AF37]/40 bg-[#FDFBF7]/80 px-4 py-1.5 font-display text-lg text-[#D4AF37] backdrop-blur">
              {g.price}
            </span>
          </div>
          <div className="p-7">
            <h3 className="font-display text-xl text-[#8A6D1F]">{g.name}</h3>
            <p className="mt-3 text-sm leading-relaxed text-[#67718A]">{g.description}</p>
            <button
              data-testid={`gift-add-button-${g.id}`}
              onClick={() => {
                prefillEnquiry({
                  event_type: "Gift & Hampers",
                  message: `I'd like to add the ${g.name} (${g.price}) to my order.`,
                });
                toast.success(`${g.name} added to your enquiry`);
              }}
              className="mt-6 flex items-center gap-2 text-sm font-medium tracking-wide text-[#D4AF37] transition-colors duration-300 hover:text-[#8A6D1F]"
            >
              <Gift size={16} />
              Add to Enquiry
            </button>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);
